import {
    Box,
    Typography,
} from '@mui/material'
import Motorcycle1 from '../../../assets/motorcycle-financing/motorcycle1.png'
import Motorcycle2 from '../../../assets/motorcycle-financing/motorcycle2.png'
import Motorcycle3 from '../../../assets/motorcycle-financing/motorcycle3.png'
import Motorcycle4 from '../../../assets/motorcycle-financing/motorcycle4.png'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMThougtSchemes: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'backgroundImage': Motorcycle1,
            'title': t('t167'),
            'content': t('t168'),
            'data': [
                t('t169'),
                t('t170'),
                t('t171'),
            ]
        },
        {
            'backgroundImage': Motorcycle2,
            'title': t('t172'),
            'content': t('t173'),
            'data': [
                t('t174'),
                t('t175'),
                t('t176'),
            ]
        },
        {
            'backgroundImage': Motorcycle3,
            'title': t('t177'),
            'content': t('t178'),
            'data': [
                t('t179'),
                t('t180'),
                t('t181'),
            ]
        },
        {
            'backgroundImage': Motorcycle4,
            'title': t('t1811'),
            'content': '',
            'data': [
                t('t1812'),
                t('t1813'),
                t('t181'),
            ]
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                flex: '1',
                display: 'flex',
                paddingLeft: '6px',
                paddingRight: '6px',
            }}>
                <Box sx={{
                    backgroundImage: `url(${data[index]['backgroundImage']})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'start',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '10px',
                }}>
                    <Box sx={{
                        width: '100%',
                        height: '100%',
                        paddingLeft: '15px',
                        paddingRight: '15px',
                        paddingTop: isTablet ? '130px' : '200px',
                        display: 'flex'
                    }}>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '10px',
                            paddingLeft: isTablet ? '10px' : '30px',
                            paddingRight: isTablet ? '10px' : '30px',
                            paddingTop: isTablet ? '20px' : '40px',
                            paddingBottom: isTablet ? '20px' : '40px',
                        }}>
                            <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                                {data[index]['title']}
                            </Typography>

                            <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'8px'}>
                                {data[index]['content']}
                            </Typography>

                            <Box>
                                {data[index]['data'].map((subItem, subIndex) => (
                                    renderTitleItem(subItem, subIndex)
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }

    const renderTitleItem = (item: string, index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: isTablet ? '10px' : '24px',
            }}>
                <Box sx={{
                    paddingTop: '9px',
                }}>
                    <Box sx={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '3px',
                        backgroundColor: '#6B6B6B'
                    }}></Box>
                </Box>
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'8px'}>
                    {item}
                </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#FFFDF7'
            }}
        >

            {/* Our Carefully Thought Schemes */}
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingTop={'60px'} paddingLeft={isTablet ? '200px' : '300px'} paddingRight={isTablet ? '200px' : '300px'}>
                    {t('t165')}
                </Typography>
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} textAlign={'center'} paddingTop={'16px'} paddingLeft={isTablet ? '200px' : '300px'} paddingRight={isTablet ? '200px' : '300px'}>
                    {t('t166')}
                </Typography>
            </Box>

            {/* Motorcycle */}
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: isTablet ? '20px' : '42px',
                paddingRight: isTablet ? '20px' : '42px',
                paddingTop: '45px',
                paddingBottom: '60px',
            }}>
                {data.map((item, index) => (
                    renderItem(index)
                ))}
            </Box>
        </Box >
    )
}

// ======================= EXPORT
export default SMThougtSchemes
